const GROUP_TYPES = {
  ROUND_ROBING: 'RoundRobin',
  BRACKET: 'Bracket',
}

export const GROUP_TYPES_TO_LECTICAL = [
  { value: GROUP_TYPES.ROUND_ROBING, label: 'Round Robin' },
  { value: GROUP_TYPES.BRACKET, label: 'Bracket' },
]

export const getGroupTypeName = (type) => {
  const groupType = GROUP_TYPES.find((gt) => gt.value === type)
  return groupType ? groupType.label : 'Unknown'
}

export default GROUP_TYPES
